export default "__VITE_ASSET__CY5$Mcys__"